<div class="incident-panel-container">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="incident-panel-title">Incidents</div>
    <span class="incident-status">
      {{incidentDetails.length}} Active
    </span>
  </div>

  <div class="incident-search-wrapper">
    <input
      type="text"
      class="form-control mb-3"
      placeholder="Filter by incident name"
      [(ngModel)]="searchQuery"
      />
    </div>

    <div class="d-flex gap-2 mb-3">
      <div class="dropdown">
        <button class="btn live-panel-button p-1  dropdown-toggle" type="button" data-bs-toggle="dropdown">
          Sort: {{ sortByOption }}
        </button>
        <ul class="dropdown-menu">
          @for (option of sortOptions; track option) {
            <li>
              <a class="dropdown-item" (click)="onSortOptionClicked(option)">{{ option }}</a>
            </li>
          }
        </ul>
      </div>
      <div class="dropdown">
        <button class="btn live-panel-button p-1  dropdown-toggle" type="button" data-bs-toggle="dropdown">
          {{ statusOption }}
        </button>
        <ul class="dropdown-menu">
          @for (option of statusOptions; track option) {
            <li>
              <a class="dropdown-item" (click)="onStatusOptionClicked(option)">{{ option }}</a>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="alert-outer custom-scroll" >
      @for (item of filteredIncidents; track item.id; let i = $index) {
        @if (item.name) {
          <div class="alert-wrapper">
            <div [id]="item.id">
              <div class="alert-header">
                <div class="alert-headerLeft">
                  <span style="font-size: 15px" (click)="goToEntity(item)">{{ item.name }}</span>
                </div>
                @if (item.status === 'active') {
                  <div class="alert-indicator" (click)="goLiveIncident(item , 'active')">
                    <i class="fa-solid fa-earth-asia"></i>
                  </div>
                }
                @if (item.status === 'pending') {
                  <div class="d-flex justify-content-end gap-1">
                    @if (item.status === 'pending') {
                      <div class="alert-indicator" (click)="goLiveIncident(item , 'pending')" title="activate">
                        <i class="fa fa-bolt"></i>
                      </div>
                    }
                    @if (item.status === 'pending') {
                      <div class="alert-indicator" (click)="closeIncident(item)" title="close">
                        <i class="fa fa-close"></i>
                      </div>
                    }</div>
                  }
                </div>
              </div>
              <div class="incident-status-container" >
                <span class="incident-status danger-incident"><i class="fa-solid fa-user"></i> {{ item.userStatuses?.danger??'0' }}</span>
                <span class="incident-status safe-incident"><i class="fa-solid fa-user"></i> {{ item.userStatuses?.safe??'0' }}</span>
                <span class="incident-status unknown-incident"><i class="fa-solid fa-user"></i> {{ item.userStatuses?.unknown??'0' }}</span>
                <span class="incident-status first-response"><i class="fa-solid fa-user"></i> 0</span>
              </div>
            </div>
          }
        }
      </div>
    </div>
    <!-- //PIN Activition-->

    <div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showPinDialog }"
      [ngStyle]="{ 'display': showPinDialog ? 'block' : 'none' }" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-md  modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Pin Verify</h5>
            <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="onPinDialogClosed(false)"></button>
          </div>
          <div class="modal-body">
            <div class="pin-wrapper">
              <app-pin-keypad [(pinValue)]="pinValue" (close)="onPinDialogClosed($event)"></app-pin-keypad>

              <div class="d-flex justify-content-center gap-2 mt-3">
                <button class="btn btn-danger btn-lightning" (click)="confirmPublicIncident(incidentDetails)">Activate And Go</button>
                <button class="btn btn-secondary" data-bs-dismiss="modal" (click)="onPinDialogClosed(false)">Cancel</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


